<template>
  <div class="widget widget_login">
    <!-- TODO: PENDIENTE AGREGAR -> idiomas -->
    <p>
      Desde nuestra plataforma podrá
      <strong>gestionar sus perros, inscripciones y documentación de forma personal con la creación de su cuenta</strong>.
      Una vez registrado en el sistema, su cuenta permanecerá abierta para todos los eventos de
      <strong>EXPODOGS.</strong>
    </p>

    <h3 class="widget-title">Acceso de usuarios</h3>
    <div class="woocommerce">
      <p>
        Si ya está registrado
        <strong>acceda con su email y su contraseña</strong>. Si es un usuario nuevo pulse en
        <strong>"crear cuenta"</strong>. En caso que no recuerde su contraseña pulse el enlace
        <strong>¿Olvidó su contraseña?</strong>
      </p>

      <form @submit.prevent="handleSubmit">
        <p
          class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide text-center"
        >
          <input
            type="email"
            placeholder="Email"
            class="w-100 form-control woocommerce-Input woocommerce-Input--text input-text"
            v-model="username"
          />
        </p>
        <p
          class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide text-center"
        >
          <input
            class="w-100 form-control woocommerce-Input woocommerce-Input--text input-text"
            placeholder="Contraseña"
            v-model="password"
          />
        </p>
        <p class="d-flex justify-content-start align-items-center">
          <label
            class="d-flex align-items-center woocommerce-form__label woocommerce-form__label-for-checkbox inline"
          >
            <input
              class="woocommerce-Input"
              type="checkbox"
              v-model="rememberMe"
              true-value="1"
              false-value="0"
            />
            <span>Recordarme</span>
          </label>
        </p>
        <p class="d-flex justify-content-between mb-10">
          <button type="submit" class="woocommerce-Button button mt-0">Acceder</button>
          <button
            type="button"
            class="woocommerce-Button2 button mt-0"
            @click="goSingup"
          >Crear cuenta</button>
        </p>
        <p class="woocommerce-LostPassword lost_password text-left">
          <a href="shop-account-password-reset.html">¿Olvidó su contraseña?</a>
        </p>
      </form>      
    </div>
  </div>
</template>
<script>
import { config } from "@/_config";
import { mapState, mapActions } from "vuex";

export default {
  name: "sidebar-login",
  data() {
    return {
      username: config.login.username,
      password: config.login.password,
      submitted: false,
      rememberMe: 0
    };
  },
  computed: {
    ...mapState("account", ["status"])
    //...mapState({alert: state => state.alert})
  },
  created() {
    // reset login status
    //this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit(e) {
      this.submitted = true;
      const { username, password, rememberMe } = this;
      if (username && password) {
        this.login({ username, password, rememberMe });
      }
    },
    goSingup() {
      this.$router.push("/signup");
    }
  }
};
</script>

